<template>
  <Section class="p-4 sm:p-6 lg:p-10">
    <div class="p-4 pt-6 mb-6 bg-white rounded-lg sm:p-6 md:mb-10 md:pt-8">
      <div class="mb-6 md:mb-8 flex flex-col items-center">
        <PromoLogo full class="logo mb-2" to="/" />

        <Button class="link text-support-lighter xxs" to="/"
          ><v-icon name="chevron-left" scale="0.7" class="mr-1" /> Back to
          Home</Button
        >
      </div>

      <h2
        class="text-center text-lg md:text-2xl lg:text-3xl mb-2 md:mb-4 lg:mt-6 text-danger"
      >
        Page Not Found (404)
      </h2>

      <p class="intro-text">
        Sorry we couldn't find the page that you were looking for. Please check
        the spelling or head back to the
        <router-link to="/">start page</router-link>.
      </p>

      <FAQs class="mt-8 lg:mt-10" />
    </div>
  </Section>
</template>

<script>
import Section from "@/components/UI/Section";
import FAQs from "@/components/FAQs/FAQs";

export default {
  name: "FourOhFour",
  components: {
    FAQs,
    Section,
  },
};
</script>

<style scoped>
.intro-text {
  @apply text-center text-sm text-support-lighter mb-2 max-w-xs mx-auto;

  @screen md {
    @apply text-base max-w-md;
  }
}
</style>
